import getRouterBasename from '@/lib/router';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import AuthCallback from 'pages/AuthCallback';
import Element from 'pages/Element';
import Env from 'pages/Env';
import Home from 'pages/Home';
import Login from 'pages/Login';
import Thread from 'pages/Thread';
import IncidentUpdatesPage from 'pages/IncidentUpdates'; // <-- add this import
import AIOpsDashboard from '@/pages/AIOpsDashboard';
import AWatch from '@/pages/AWatch';
import ChangeValidation from '@/pages/ChangeValidation';
import Feedback from './pages/Feedback';
import UserMetrics from './pages/UserMetrics';


export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <AIOpsDashboard />
    },
    {
      path: '/askawatch',
      element: <Home />
    },
    {
      path: '/changevalidation',
      element: <ChangeValidation />
    },
    {
      path: '/feedback',
      element: <Feedback />
    },
    {
      path: '/metrics',
      element: <UserMetrics />
    },
    {
      path: '/env',
      element: <Env />
    },
    {
      path: '/thread/:id?',
      element: <Thread />
    },
    {
      path: '/element/:id',
      element: <Element />
    },
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/login/callback',
      element: <AuthCallback />
    },
    {
      path: '/incidentcommunication',
      element: <IncidentUpdatesPage /> 
    },
    {
      path: '/awatch',
      element: <AWatch /> 
    },
    {
      path: '*',
      element: <Navigate replace to="/" />
    }
  ],
  { basename: getRouterBasename() }
);
